export default [
  {
    name: "OneTimeTaskProfile",
    path: "/one-time-task-profile/:id"
  },
  {
    name: "TaskProfile",
    path: "/task-profile/:id/:uniqueId/:taskDate"
  },
  {
    name: "Calendar",
    path: "/calendar"
  }
];
